import { Modal } from 'react-bootstrap';
import CloseIcon from '../components/icons/CloseIcon';
import { PRIVACY_POLICY, TERMS_OF_USE } from '../constants/legalContent';

function LegalBody({ doc }) {
  return (
    <div className="legalDocumentContent">
      <h1>{doc.title}</h1>
      {doc.intro?.map((text) => (
        <p key={text.slice(0, 48)}>{text}</p>
      ))}
      {doc.sections?.map((section) => (
        <div key={section.heading}>
          <h2>{section.heading}</h2>
          {section.blocks?.map((block, index) => (
            <div key={`${section.heading}-${index}`}>
              {block.sub ? <h3>{block.sub}</h3> : null}
              {block.paragraphs?.map((text) => (
                <p key={text.slice(0, 48)}>{text}</p>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

/**
 * Same UI/UX as ticket-kiosk / AI station LegalDocumentModal.
 * type: 'terms' | 'privacy'
 */
function LegalModal({ show, type, onHide }) {
  const doc = type === 'privacy' ? PRIVACY_POLICY : TERMS_OF_USE;
  const title = type === 'privacy' ? 'Privacy Policy' : 'Terms of Use';

  return (
    <Modal
      show={show}
      onHide={onHide}
      animation
      backdrop="static"
      keyboard={false}
      centered
      scrollable
      size="lg"
      enforceFocus={false}
      className="legalDocumentModal"
      backdropClassName="legalDocumentModalBackdrop"
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <button type="button" className="btnClose" onClick={onHide} aria-label="Close">
          <CloseIcon />
        </button>
      </Modal.Header>
      <Modal.Body>
        <LegalBody doc={doc} />
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <button type="button" className="btnPrimary" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default LegalModal;
